import t from "@/lang/lang";
import { DataCard } from "@/routes/processes/[processId]/htz/offers/[offerId]/data/_components/data-card";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { useParams } from "react-router";

export function DataRoute() {
  const { offerId } = useParams();

  return (
    <div className="grid gap-2">
      <DataCard />
      <Textblocks
        subdomain={GSMSubdomain.HTZ}
        documentKind={GSMDocumentKind.Offer}
        documentId={offerId!}
        title={t("Bemerkungen im Angebot")}
        defaultOpen={false}
      />
    </div>
  );
}
